import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { of, from, Subscription, } from 'rxjs';
import { tap, map, switchMap, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table, TableFilterEvent } from 'primeng/table';
import { Title } from "@angular/platform-browser";
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry } from 'src/app/shared/doc-list-entry';
import { RestApiService } from 'src/app/services/rest-api.service';
import { extend } from 'lodash';

class NotPaidOrdersList extends DocListEntry {
  SHIPFIRSTDATE?: Date;
  SHIPLASTDATE?: Date;
  unpaidSum?: number;
  unpaidDays?: number;
}

@Component({
  selector: 'app-home-not-paid-orders-list',
  templateUrl: './home-not-paid-orders-list.component.html',
  styleUrls: ['./home-not-paid-orders-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeNotPaidOrdersListComponent implements OnInit, OnDestroy, OnChanges {

  @Input() today: Date;
  @Input() clean: boolean = true;

  globalSettinsData: GlobalSettingsData;

  @ViewChild('ptable5') ptable5: Table;

  notPaidOrdersList: NotPaidOrdersList[];
  notPaidSelectedDocument: NotPaidOrdersList;
  notPaidOrdersQuery: Subscription;
  totalNotPaidOrders: number;

  loading: boolean = false;

  totalInvoiceSum: number = 0;
  totalPaidSum: number = 0;
  totalShippedSum: number = 0;

  monthToLoad: number = 12;
  monthToLoadMin: number = 6;
  monthToLoadMax: number = 60;

  cf: any = {}
  constructor(
    private restapi: RestApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
    private titleService: Title,

  ) { }

  loadNotPaidOrdersList() {
    this.notPaidOrdersQuery =
      of({ mc: this.globalSettinsData.mainCompanyId, depth: this.monthToLoad * 30, date: this.today })
      .pipe(

        debounceTime(200),
        distinctUntilChanged(),

        switchMap(opt => this.restapi.getNotPaidOrdersList(opt.mc, opt.depth, opt.date).pipe(

          tap(() => this.loading = true),
          tap(data => environment.production || console.table(data)),

          map(data => {
            this.notPaidOrdersList = data || [];
          //  return from(this.notPaidOrdersList).pipe(
          //    map(e => extend(new NotPaidOrdersList(), e)),
          //    map(e => {
          //      return e;
          //    }),
          //  );
          }),

          finalize(() => {
            this.totalNotPaidOrders = this.notPaidOrdersList.length;
            this.docListCalculatedFields(this.notPaidOrdersList);
            this.totalInvoiceSum = this.notPaidOrdersList.reduce((s, e) => s += e.DOCSUM, 0);
            this.totalPaidSum = this.notPaidOrdersList.reduce((s, e) => s += e.PAYDSUM, 0);
            this.totalShippedSum = this.notPaidOrdersList.reduce((s, e) => s += e.SHIPSUM, 0);
            this.loading = false;
          })
        )))
        .subscribe({
          error: (err) => {
            console.error(err);
            this.loading = false;
          }           
          });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** HomeNotPaidOrdersListComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clean':
          this.clearSavedSettings();

        case 'today':
          if (this.globalSettinsData) {
            this.loadNotPaidOrdersList()
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomeNotPaidOrdersListComponent in ngOnDestroy");

    if (this.notPaidOrdersQuery) { this.notPaidOrdersQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** HomeNotPaidOrdersListComponent in ngOnInit");
    this.titleService.setTitle('Не оплаченные заказы - домашняя страница');
    this.today = new Date();

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.loadNotPaidOrdersList()
  }

  onPaidRowSelect(event) {
    //console.log('*** HomeNotPaidOrdersListComponent onRowSelect: ' + JSON.stringify(event.data))
  }

  onStateSave(state) {
    console.log('*** HomeNotPaidOrdersListComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestoreNotPaid(state) {
    console.log('*** HomeNotPaidOrdersListComponent onStateRestoreNotPaid: ' + JSON.stringify(state));

    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        let fltValue = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
        this.cf[f] = fltValue;
      }
    }
  }

  docListCalculatedFields(orderList: NotPaidOrdersList[]) {

    let jn: Date = new Date();
    let td: Date = new Date();
    td.setHours(0, 0, 0, 0);
    let tm: Date = new Date(td);
    tm.setHours(23, 59, 59);

    orderList.forEach(dc => {
      dc.SHIPFIRSTDATE = (dc.SHIPSUM > 0) ? new Date(dc.SHIPFIRSTDATE) : null;
      dc.SHIPLASTDATE = (dc.SHIPSUM > 0) ? new Date(dc.SHIPLASTDATE) : null;
      dc.unpaidSum = dc.DOCSUM - dc.PAYDSUM;
      dc.unpaidDays = (dc.SHIPFIRSTDATE) ? Math.round((jn.getTime() - dc.SHIPFIRSTDATE.getTime()) / (1000 * 3600 * 24)) : null;

      dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

      dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

      dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

      dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

      dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

      dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

      dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

      dc.fd = (new Date(dc.DOCDATE) > tm);
    });
  }

  onFilterEvent(event: TableFilterEvent) {
    console.log('*** HomeNotPaidOrdersListComponent onFilterEvent: ' + JSON.stringify(event));

    this.totalInvoiceSum = event.filteredValue.reduce((s, e) => s += e.DOCSUM, 0);
    this.totalPaidSum = event.filteredValue.reduce((s, e) => s += e.PAYDSUM, 0);
    this.totalShippedSum = event.filteredValue.reduce((s, e) => s += e.SHIPSUM, 0);
  }

  clearSavedSettings() {
    try {
      this.ptable5.clearState();
    } catch (e) {
      console.log('*** HomeNotPaidOrdersListComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
    this.clean = false;
  }

  reloadTable(event) {
    console.log('*** HomeNotPaidOrdersListComponent reloadTable: ' + JSON.stringify(event));

    this.loadNotPaidOrdersList();
  }

  clearOrResetTableFilter(event) {
    console.log('*** HomeRecentOrdersListComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.clearSavedSettings();
  }

  onSlideEnd(event) {
    console.log('*** ProductListPaidComponent onSlideEnd: ' + event.value)
    let md: Date = new Date();
    md.setMonth(md.getMonth() - this.monthToLoad);
    this.loadNotPaidOrdersList();
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** HomeRecentOrdersListComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.notPaidOrdersList);

      const exportData: any =
        this.notPaidOrdersList.map(e => ({

          'Документ': e.DOCNAME,
          'Номер': e.DOCNUMBER,
          'Дата': new Date(e.DOCDATE),
          'Покупатель': e.CLIENTSNAME,
          'Ответственный': e.PERSONNAME,
          'Продавец': e.LOCALCOMP,
          'Менеджер': e.AUTHOR,
          'Сумма': e.DOCSUM,
          'Оплачено': e.PAYDSUM,
          'Отгружено': e.SHIPSUM,
          'Валюта': e.CURSTR,
          'Курс': e.DOCRATEVAL,
          'Примечание продавца': e.DOCNOTE1,
          'Примечание покупателя': e.DOCNOTE2,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { documents: worksheet }, SheetNames: ['documents'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "documents");
    });
  }
}
